<template>
  <span class="sch" :class="`sch--${toneName}`">{{ text }}</span>
</template>

<script>
import { STATUS_LABELS } from "@/constants/application.constants";

// Soft pill used for application statuses in the redesigned (ECU theme) tables.
// Same status keys as StatusBadge, so it is a drop-in replacement.
// Tones: orange, green, blue, amber, teal, emerald, red, grey.
const TONES = {
  inprogress: "orange",
  submitted: "green",
  in_review: "blue",
  incomplete: "amber",
  verified: "teal",
  approved: "emerald",
  rejected: "red",
};

export default {
  name: "StatusChip",
  props: {
    status: { type: String, default: "" },
    // optional overrides for non-application chips (e.g. staff "Active" / "Inactive")
    label: { type: String, default: "" },
    tone: { type: String, default: "" },
  },
  computed: {
    text() {
      return this.label || STATUS_LABELS[this.status] || this.status || "";
    },
    toneName() {
      return this.tone || TONES[this.status] || "grey";
    },
  },
};
</script>

<style scoped>
.sch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 108px;
  padding: 6px 16px;
  border-radius: 999px;
  font-size: var(--ecu-fs-small);
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  background: #eef0f6;
  color: #4b5675;
}
.sch--orange { background: #fff0e4; color: #e8590c; }
.sch--green { background: #e1f6e8; color: #138a3e; }
.sch--blue { background: #e4efff; color: #1d5fd1; }
.sch--amber { background: #fff6d6; color: #a06a00; }
.sch--teal { background: #dff5f3; color: #0b7f78; }
.sch--emerald { background: #d3f1de; color: #0b6b33; }
.sch--red { background: #fde9e9; color: #c52222; }
</style>